const Commission = () => {
  return (
    <div>
      <h2>Commission</h2>
      <p>TODO</p>
    </div>
  );
};
export default Commission;
